import { OperacaoParcela } from './model/operacaoParcela';

// A natureza financeira pertence ao pagamento, não ao saldo remanescente.
export const calcularTotaisBaixaFinanceira = (parcelas: OperacaoParcela[]) => {
  const total = parcelas.reduce((soma, parcela) => soma + Math.max(0, parcela.valorPago ?? 0), 0);
  return { valorBruto: total, saldoDevedor: total, desconto: 0 };
};
